import { AxiosPromise } from 'axios';
import { ProviderApiItem } from 'features/Provider/types';
import { RentalApiItem } from 'features/Rental/types';
import { createResourceApi, DEFAULT_FETCHED_ITEMS_PER_AGE } from 'resources/ResourceApi';
import { normalizeUri, requestApi } from 'services/axios';
import { CollectionJsonLD } from 'typings/api';
import { AddAccessFormValues } from 'typings/forms';

export const apiKey = 'providers';

const rentals = (
    provider: string,
    page: number,
    itemsPerPage = DEFAULT_FETCHED_ITEMS_PER_AGE,
): AxiosPromise<CollectionJsonLD<RentalApiItem>> => {
    const queryParameters = {
        page,
        itemsPerPage,
    };
    return requestApi({
        url: `${normalizeUri(apiKey, provider)}/rentals`,
        params: queryParameters,
    });
};

const grantAccess = (provider: string): AxiosPromise<ProviderApiItem> =>
    requestApi({
        url: `${normalizeUri(apiKey, provider)}/grant_access`,
        method: 'GET',
        showBackdrop: true,
    });

const revokeAccess = (provider: string): AxiosPromise<ProviderApiItem> =>
    requestApi({
        url: `${normalizeUri(apiKey, provider)}/revoke_access`,
        method: 'GET',
        showBackdrop: true,
    });

const addAccess = (provider: string, data: AddAccessFormValues): AxiosPromise<ProviderApiItem> =>
    requestApi({
        url: `${normalizeUri(apiKey, provider)}/add_access`,
        method: 'POST',
        data: {
            user: data,
        },
    });

export default { ...createResourceApi<ProviderApiItem>(apiKey), addAccess, grantAccess, rentals, revokeAccess };
